import { createContext, useContext, useEffect, useState } from 'react';
import Modal from './Modal';
import { setConfirmHandler } from '../utils/confirm';

const ModalContext = createContext(null);

export function ModalProvider({ children }) {
  const [content, setContent] = useState(null);
  const [wide, setWide] = useState(false);
  const [confirmState, setConfirmState] = useState(null); // { message, title, okText, danger, resolve }

  // openModal(node, { wide: true }) -> modal rộng cho bảng nhiều cột.
  const openModal = (node, opts = {}) => {
    setContent(node);
    setWide(!!opts.wide);
  };
  const closeModal = () => setContent(null);

  // confirm(message, opts) -> Promise<boolean>. Thay window.confirm (hộp thoại trình duyệt) bằng modal căn giữa.
  const confirm = (message, opts = {}) =>
    new Promise((resolve) => {
      setConfirmState({
        message,
        title: opts.title || 'Xác nhận',
        okText: opts.okText || 'Đồng ý',
        cancelText: opts.cancelText || 'Hủy',
        danger: opts.danger !== false, // mặc định nút OK màu nguy hiểm (đa số dùng để xác nhận xóa)
        resolve,
      });
    });
  const answer = (val) => {
    if (confirmState) confirmState.resolve(val);
    setConfirmState(null);
  };

  // Đăng ký handler confirm dùng chung (cho các file gọi confirm() trực tiếp).
  useEffect(() => { setConfirmHandler(confirm); }, []);

  return (
    <ModalContext.Provider value={{ openModal, closeModal, confirm }}>
      {children}
      <Modal open={!!content} onClose={closeModal} wide={wide}>
        {content}
      </Modal>

      {/* Hộp thoại xác nhận căn giữa màn hình */}
      <Modal open={!!confirmState} onClose={() => answer(false)}>
        {confirmState && (
          <div style={{ width: 'min(420px, 90vw)' }}>
            <h3 style={{ marginBottom: 10 }}>{confirmState.title}</h3>
            <div style={{ marginBottom: 18, whiteSpace: 'pre-wrap' }}>{confirmState.message}</div>
            <div className="row" style={{ gap: 8 }}>
              <div className="spacer" />
              <button className="btn ghost" onClick={() => answer(false)}>{confirmState.cancelText}</button>
              <button className={`btn${confirmState.danger ? ' danger' : ''}`} onClick={() => answer(true)} autoFocus>
                {confirmState.okText}
              </button>
            </div>
          </div>
        )}
      </Modal>
    </ModalContext.Provider>
  );
}

export function useModal() {
  return useContext(ModalContext);
}
